import React from 'react'
import { motion } from "framer-motion"

const loading = {
  initial: {
    transition: {
      staggerChildren: .2
    }
  },
  animate: {
    transition: {
      staggerChildren: .2
    }
  }
}
const circle = {
  initial: {
    y: "0%",
  },
  animate: {
    y: "100%",
  },
}

const transition = {
  duration: 0.5,
  yoyo: Infinity,
  ease: "easeInOut",
}

const Spinner = () => {
  return (
    <motion.div initial="initial" animate="animate" variants={loading} className="w-14 h-5 flex justify-between items-end">
      <motion.span variants={circle} transition={transition} className="block w-3 h-3 bg-orange-500 rounded-full border-orange-50 border-2 opacity-80"/>
      <motion.span variants={circle} transition={transition} className="block w-3 h-3 bg-orange-500 rounded-full border-orange-50 border-2 opacity-80"/>
      <motion.span variants={circle} transition={transition} className="block w-3 h-3 bg-orange-500 rounded-full border-orange-50 border-2 opacity-80"/>
    </motion.div>
  )
}

export default Spinner